import React from 'react';
import cn from 'classnames';

import VideoHls from 'react-scale/components/tailwind/VideoHls';
import Radio from './Radio';

import styles from './TaskResponseVideoClassification.module.css';

class TaskResponseVideoClassification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: false,
      subcategory: false,
      animate: false
    };
  }

  onShowAnnotations = () => {
    this.setState({ animate: true }, () => {
      this.categoryTimeout = setTimeout(() => {
        this.setState({ category: true });
        clearTimeout(this.categoryTimeout);
      }, 1000);
      this.subcategoryTimeout = setTimeout(() => {
        this.setState({ subcategory: true });
        clearTimeout(this.subcategoryTimeout);
      }, 1800);
    });
  };

  render() {
    const { category, subcategory, animate } = this.state;
    return (
      <div className="relative">
        <VideoHls
          src="https://stream.mux.com/FQZncYQtAsytwEQuOS2D37MVMi7hE25K.m3u8"
          poster="https://image.mux.com/FQZncYQtAsytwEQuOS2D37MVMi7hE25K/thumbnail.png?width=20&fit_mode=pad&time=0"
          muted
          playsinline
          controls={false}
          autoPlay
          loop
          playStopOnViewportChange
          callback={this.props.withAnnotations ? this.onShowAnnotations : () => null}
        />
        <div
          className={cn(
            styles.sideDrawer,
            { [`${styles.animate}`]: animate },
            'bg-gray-200 p-2 absolute top-0 right-0 bottom-0 z-10 overflow-auto'
          )}
        >
          <p className="text-base text-black">Category</p>
          <ul className="pointer-events-none">
            <Radio>Sport</Radio>
            <Radio checked={category}>Lifestyle</Radio>
            <Radio>Drama</Radio>
          </ul>
          <div className={cn(styles.bottomList, 'opacity-0')}>
            <p className="text-base text-black mt-1">Sub-category</p>
            <ul className="pointer-events-none">
              <Radio checked={subcategory}>Cooking</Radio>
              <Radio>Fashion</Radio>
              <Radio>Arts & Craft</Radio>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

TaskResponseVideoClassification.defaultProps = {
  withAnnotations: false
};

export default TaskResponseVideoClassification;
